export default __webpack_public_path__ + "static/media/ciboa.5f24e81f.png";